import { classNames } from "repoV2/utils/common/render/classNames";
import React, { FC } from "react";
import commonStyles from "../../../event.module.scss";
import styles from "./helperComponents.module.scss";
import { IHelperComponents } from "./IHelperComponents";

export const Variant: FC<IHelperComponents.IVariant> = ({
    variantOption,
    onClick,
    isSelected,
}) => {
    const { options, type } = variantOption;

    return (
        <div>
            <div className={commonStyles.sidebarTitle}>{type}</div>
            <div key={type} className={styles.options} role="button">
                {options.map(option => (
                    <div
                        key={option}
                        className={classNames(
                            styles.option,
                            isSelected({ type, option }) && styles.selected
                        )}
                        onClick={e => onClick?.(e, { type, option })}
                    >
                        {option}
                    </div>
                ))}
            </div>
        </div>
    );
};
